<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->
<lms-message-tab *ngIf="selectedTab && selectedTab.subTypeDetail?.data?.message" [message]="selectedTab.subTypeDetail?.data?.message"
  (clearMessage)="clearErrorMessage($event)">
</lms-message-tab>
<div class="clearfix"></div>
<lms-query-view-header [tab]="selectedTab" [tabs]="filteredTabs" [locoStatusArr]='[]' [lastRefreshTime]='lastRefreshTime' (refreshBtnEvent)="refreshbtnEvent($event)"></lms-query-view-header>
<div class="clearfix"></div>
<lms-query-view-filters [tab]="selectedTab" (searhType)="getSearchType($event)"></lms-query-view-filters>
<div class="clearfix"></div>
<lms-query-view-data-container [searchType]="searchType" [loadData]="loadData" [searchResult]="searchResult" *ngIf="selectedTab?.subTypeDetail[selectedTab.subType.toLowerCase()]?.status === 'loaded'"></lms-query-view-data-container>